import {computed, ref} from 'vue';
import type {LocationQuery, RouteLocationRaw} from 'vue-router';

import settings from '@/config/settings';

const QUERY_KEY = 'standalone';

const parseQueryValue = (value: unknown): boolean | null => {
  if (value == null) return null;
  return value === 'true' || value === true;
};

const standaloneRef = ref<boolean>(settings.SERVICES.FRONTEND.STANDALONE);

export const isStandalone = computed(() => standaloneRef.value);

const isStandaloneQueryValue = (value: unknown): boolean =>
  value === 'true' || value === true;

export const standaloneState = {
  isStandalone,

  initFromQuery(query: LocationQuery | undefined): void {
    const parsed = parseQueryValue(query?.[QUERY_KEY]);
    if (parsed === null) return;
    standaloneRef.value = parsed;
    settings.SERVICES.FRONTEND.STANDALONE = parsed;
  },

  set(value: boolean): void {
    standaloneRef.value = value;
    settings.SERVICES.FRONTEND.STANDALONE = value;
  },

  withStandalone(target: RouteLocationRaw): RouteLocationRaw {
    if (!standaloneRef.value) return target;
    const raw = target as {
      path?: string;
      name?: string;
      query?: Record<string, unknown>;
    };
    const currentValue = raw.query?.[QUERY_KEY];
    if (isStandaloneQueryValue(currentValue)) return target;
    return {
      ...raw,
      query: {
        ...(raw.query ?? {}),
        [QUERY_KEY]: 'true',
      },
    };
  },
};
